<template>
  <div class="v-profile-photo-uploader__wrapper">
    <div class="profile-photo-wrapper">
      <h3>Profile Photo</h3>
    </div>

    <div class="avatar-wrapper">
      <VAvatar
        :image="_avatarImg"
        :useInitials="!_avatarImg"
        :firstName="_userInitials.first_name"
        :lastName="_userInitials.last_name"
        width="50px"
        height="50px"
        :clickable="false"
      ></VAvatar>
    </div>

    <div class="profile-photo-buttons-wrapper">
      <VButton
        label="Upload New Photo"
        size="regular"
        @click="_uploadHandler"
        :disabled="isLoading"
        inverted
      ></VButton>

      <div v-if="_avatarImg" class="remove-photo" @click="_removePhotoHandler">
        Remove photo
      </div>
    </div>

    <input
      type="file"
      accept="image/*"
      ref="upload"
      @change="_onFileChange"
      @click="e => (e.target.value = null)"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

// components
import VAvatar from "@/components/VAvatar";

import withToasted from "@/mixins/withToasted";

export default Vue.component("AccountProfilePhotoUploader", {
  components: {
    VAvatar
  },

  mixins: [withToasted],

  methods: {
    _removePhotoHandler() {
      this.updateUser({
        values: { profile_image_url: null },
        onSuccess: () => {
          this.toast("Account image has been deleted");
        }
      });
    },

    _uploadHandler() {
      this.$refs.upload.click();
    },

    _onFileChange(e) {
      const { upload } = this.$refs;
      this.updateAccountImage({
        file: upload.files[0],
        onSuccess: () => {
          this.toast("Photo Uploaded Successfully", "success", {
            icon: "check"
          });
        },
        onError: () => {
          this.toast("Something went wrong during uploading image.", "error");
        }
      });
    },

    // ...mapActions("acccount", []),
    ...mapActions("account", ["updateAccountImage", "updateUser"])
  },

  computed: {
    _avatarImg() {
      return this.getUser && this.getUser.profile_image_url;
    },

    _userInitials() {
      if (!this.getUser) {
        return {};
      }

      const { first_name, last_name } = this.getUser;
      return { first_name, last_name };
    },

    ...mapGetters("account", ["getUser", "isLoading"])
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-profile-photo-uploader";

.#{$ns} {
  &__wrapper {
    input {
      display: none;
    }

    .profile-photo-wrapper {
      margin-top: 30px;
      margin-bottom: 30px;

      h3 {
        margin-bottom: 30px;
        font-size: 16px;
        font-family: Lato-Regular, sans-serif;
        color: $secondary-text-color;
      }
    }

    .profile-photo-buttons-wrapper {
      margin-top: 30px;
      margin-bottom: 30px;

      .remove-photo {
        height: $input-height;
        color: $primary-color;
        letter-spacing: 0.2px;
        font-size: 15px;
        cursor: pointer;
        margin-top: 15px;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
